import React from 'react';
import { css } from '@emotion/react';
import { fontSizes, fontWeights, gutterSizes, lineHeights } from '../../base/theme';

export const AttributesStyle = (showSeparator: boolean) => css`
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.normal};
    line-height: ${lineHeights.base};
    min-height: 20px;

    margin-bottom: ${gutterSizes.base};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    b {
        font-weight: ${fontWeights.bold};
    }

    ${showSeparator &&
    `
        span:not(:last-of-type) {
            &:after {
                content: ' | ';
                font-size: ${fontSizes.base};
                font-weight: ${fontWeights.normal};
                vertical-align: bottom;
            }
        }
    `}
`;

export const Attributes = ({
    children,
    showSeparator = true,
    ...props
}: React.PropsWithChildren & { showSeparator?: boolean }) => {
    return (
        <div css={AttributesStyle(showSeparator)} {...props}>
            {children}
        </div>
    );
};
